import { render, staticRenderFns } from "./tao2.vue?vue&type=template&id=0dbe0009&scoped=true&"
import script from "./tao2.vue?vue&type=script&lang=js&"
export * from "./tao2.vue?vue&type=script&lang=js&"
import style0 from "./tao2.vue?vue&type=style&index=0&id=0dbe0009&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbe0009",
  null
  
)

export default component.exports